import { useContext, useEffect, useState } from 'react'

import getCookieByName from '../../helpers/get-cookie-by-name'
import { AmplitudeContext } from '../amplitude-context'

const useAmplitudeCookies = () => {
  const instance = useContext(AmplitudeContext)?.instance ?? null
  const [amplitudeSessionId, setAmplitudeSessionId] = useState<string | null>(null)
  const [amplitudeDeviceId, setAmplitudeDeviceId] = useState<string | null>(null)

  useEffect(() => {
    if (!instance) return
    let isActive = true

    void instance.initialized.then(() => {
      if (!isActive) return

      const currentDeviceId = instance.client.getDeviceId()
      const currentSessionId = instance.client.getSessionId()

      if (currentDeviceId && getCookieByName('amplitudeDeviceId') !== currentDeviceId) {
        document.cookie = `amplitudeDeviceId=${currentDeviceId}; path=/;`
      }
      if (currentSessionId && Number(getCookieByName('amplitudeSessionId')) !== currentSessionId) {
        document.cookie = `amplitudeSessionId=${currentSessionId}; path=/;`
      }

      setAmplitudeDeviceId(currentDeviceId ?? null)
      setAmplitudeSessionId(currentSessionId ? currentSessionId.toString() : null)
    })

    return () => {
      isActive = false
    }
  }, [instance])

  return { deviceId: amplitudeDeviceId, sessionId: amplitudeSessionId }
}

export default useAmplitudeCookies
